export default "https://assets.egbcdn.net/assets/packs/_/images/logo-egb-8efc870520ac4c0f36d9409a15ae4b39.svg";